export interface Attendee {
  email: string
  is_organizer: boolean
  is_optional: boolean
  is_resource: boolean
  type: 'required' | string // Use string if there are other possible values
  response_status?: string // If 'response_status' is sometimes present
  self?: boolean // If 'self' is sometimes present
  // Add any other properties you observe in your data
}

interface DateTimeInfo {
  date_time: string
  time_zone: 'America/Edmonton' | string // Be specific if you know the possible values
}

export interface ConferenceInfo {
  provider: 'google_meet' | string // Be specific if you know the possible values
  url: string
}

export interface OrganizerInfo {
  email: string
  display_name: string
}

export interface CalendarEvent {
  attendees: Attendee[]
  body: string
  calendar_id: string
  conference?: ConferenceInfo // Optional, as it might not always be present
  created_at: string
  end: DateTimeInfo
  event_type: 'default' | string // Be specific if you know the possible values
  id: string
  is_all_day: boolean
  is_attendees_list_hidden: boolean
  is_cancelled: boolean
  master_event_id: string
  object: 'CalendarEvent'
  organizer: OrganizerInfo
  recurrence?: string[] // Optional, as it might not always be present
  start: DateTimeInfo
  title: string
  transparency: 'transparent' | string // Be specific if you know the possible values
  updated_at: string
  visibility: 'private' | string // Be specific if you know the possible values
}

// Define the available views
export const VIEWS = {
  DAY: 'day',
  WEEK: 'week',
  MONTH: 'month',
}
